import gql from "graphql-tag";
import ManagerInfo from "./components/profile/ManagerInfo";
import StoreInfo from "./components/profile/StoreInfo";
import { SEANCE } from "./utils/constants";

export const ME = gql`
  {
    me {
      id
      email
      mobile
      store {
        id
        name
        banner
        logo
        contract
        feePaid
        stripeAccountId
        acceptCGV
        nidFront
        nidBack
        siretDoc
        rib
        driversMode
        deliveryMode
        contact {
          tel
          email
        }
        storeType {
          authorizeAddons
          authorizeMenuManagement
        }
      }
      address {
        country
      }

      profile {
        firstName
        lastName
        photoUrl
        birthdate
      }
    }
  }
`;
export const MENUS_ACTIVE = gql`
  query menusActive {
    menusActive {
      id
      name
      price
    }
  }
`;
export const STRIPE_LINK = gql`
  {
    stripeSignUpLink
  }
`;

export const MY_STORE = gql`
	{
		myStore {
			id
			banner
			responsible {
				id
			...ResponsibleDetails
			}
			...StoreDetails
			workingHours {
				monday {
        ${SEANCE}
				}
				tuesday {
					${SEANCE}
					}
			  wednesday {
						${SEANCE}
						}
				thursday {
					${SEANCE}
					}
				friday {
					${SEANCE}
					}
				saturday {
					${SEANCE}
					}
				sunday{
					${SEANCE}
					}
			}
		}
	}

	${ManagerInfo.fragments.responsibleDetails}
	${StoreInfo.fragments.storeDetails}

`;
